<template>
 <div class="wrapper" id='container1'>  
  <CRow class="mt-3">
    <CCol sm="12" lg="4">
      <CCard  >
          <CCardHeader>
            <b>Article Detail</b> 
          </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <label> Article Title :  </label>
              <p > <b> {{ datas.data.title }} </b> </p> 
              <hr>
              <label> Author :  </label>
              <p >  <b> {{ datas.data.author }} </b> </p>
              <hr>
              <label> Category Article :  </label>
              <p >  <b> {{ datas.data.article_category.title }} </b> </p>
              <hr>
              <label> Publish Date :  </label>
              <p >  <b> {{ datas.data.publish_date }} </b> </p>
              <hr>
              <label> Is Publish ?   </label>
              <p >  <b> {{ datas.data.is_publish }} </b> </p>
              <hr>
              <label> Is Active ?   </label>
              <p >  <b> {{ datas.data.is_active }} </b> </p>
              <hr>
            <label> Background Image </label>
            <CRow >
              <CCol  >
              <img class="mt-2" v-bind:src="datas.data.bg_image" style="width:70%"/>
              </CCol>
            </CRow>    
            </CCol>
          </CRow>  
        </CCardBody>   
      </CCard>
    </CCol>   
    <CCol sm="12" lg="8">
      <CCard>   
        <CCardHeader>
          <b>Rich Text</b> 
        </CCardHeader>
          <CCardBody>
            <CRow >
              <CCol class="ml-2"  >
             <editor id="editor" v-model="datas.data.rich_text" api-key="hq3wl53w9617r84m5cjgkm5h18xckn5mtfl0bvlkkytchrv8" :init="init">{{ datas.data.rich_text }}</editor>
              </CCol>
            </CRow>
          </CCardBody>
      </CCard>
    </CCol>
  </CRow>
<!-- <pre>{{ $data | json }}</pre> -->     
  <alertmodal></alertmodal>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_article_category.vue'
import Editor from '@tinymce/tinymce-vue';
import alertmodal from '@/views/alert/modal.vue';
import article from '@/services/article'
import event from '@/services/event'
import EventBus from '@/eventBus';
import store from '@/store.js'

export default {
  name: 'article',
  components: { alertmodal, Datatable, 'editor': Editor, },
  data(){
    return{
      updateSubmit: false,
      largeModal:false,
      mode:'',
      cardCollapse: true,
      datas:[],
       fields: [
          {key: 'title', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'title',
      sortByDesc: false,
      is_active: 1,
      init: {
            height: 500,
            init_instance_callback : function(editor) {
                var freeTiny = document.querySelector('.tox .tox-notification--in');
            freeTiny.style.display = 'none';
            },
            plugins: [
            'advlist autolink lists link image charmap',
            'searchreplace visualblocks',
            'insertdatetime table paste code wordcount'
            ],
            content_style: "body { background-color: #32323D; }",
            toolbar:
            'undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat ',
            images_upload_credentials: true,
            //images_upload_url: 'http://localhost:3300/imageupload/postAcceptor.php',
            images_upload_handler: function (blobInfo, success, failure) {
            var xhr, formData;
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            //xhr.open('POST', 'http://localhost:8005/api/testupload');
            xhr.open('POST', process.env.VUE_APP_URL +'/upload_image_tinymce');
            xhr.onload = function() {
                var json;

                if (xhr.status != 200) {
                failure('HTTP Error: ' + xhr.status);
                return;
                }
                json = JSON.parse(xhr.responseText);

                if (!json || typeof json.location != 'string') {
                failure('Invalid JSON: ' + xhr.responseText);
                return;
                }
                success(json.location);
            };
            formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            xhr.send(formData);
            }
        },   
      //end
    }
    //end
  },

  created() {
      //this.loadData()
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE_ARTICLE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

   beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('TABLE_UPDATE_ARTICLE')
  },
   
  methods: {
    openNew: function (){
      this.$router.push({name:'Article Form'})
    },
     openShow(id){
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit section') !== -1){
          //IF ALLOW
        var params = {title: 'Show Article', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_SHOW_ARTICLE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
    openEdit(id){
      this.$router.push({name:'Article Form',query: {id:id} })
    },
    openURL(data){
        this.$router.push({name:'Article',query: {Pud:data} }) 
    }, 
    openPosition: function () {
      this.$router.push({name:'Article Position'})
    },
    publish(id){   
      if(confirm("Do you really want to publish this article?")){
        article.publishArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },
     unpublish(id){   
       if(confirm("Do you really want to unpublish this article?")){
        article.unpublishArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //SET END
    },
    deactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete section') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        article.deactivateArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    reactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete section') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        article.reactivateArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    destroy(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete section') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete?")){
        article.destroyArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_ARTICLE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

    article.getArticlebyID(this.$route.query.id, params)
        .then(res => {
            this.datas = res; 
          if(this.datas.data.is_active === 0){
            this.datas.data.is_active = 'No'
          }else{
            this.datas.data.is_active = 'Yes'
          }
          if(this.datas.data.is_publish === 0){
            this.datas.data.is_publish = 'No'
          }else{
            this.datas.data.is_publish = 'Yes'
          }
          let getData = res.data
          this.items = getData.data
          
          //this.items = res.data.event_order
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
          
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShowArticle(val) {
        this.openShow(val) 
    }, 
    handleEditArticle(val) {
        this.openEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handlechangeToPublish(val) {
        this.publish(val) 
    },  
    handlechangeToUnpublish(val) {
        this.unpublish(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleDestroy(val) {
        this.destroy(val)       
    },
  }
}
</script>
